import React, { useContext, useEffect, useRef, useState } from "react";

import { MaterialReactTable } from "material-react-table";
import { Plane } from "lucide-react";
import { base_url } from "../../config";
import axios from "axios";
import VisaModal from "./VisaModal";
import RegistrationContext from "../../contexts/RegistrationContext";

const VisaTable = () => {
  const [data, setData] = useState([]);
  const [code, setCode] = useState("");
  const [type, setType] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [rowData, setRowData] = useState(null);
  const skippedRef = useRef(new Set());
  const { reloadAdminBadges, setReloadAdminBadges } = useContext(RegistrationContext);

  const visaKey = (r) => `${r.code}::${r.type}`;

  const fetchVisa = async () => {
    try {
      const response = await axios.get(`${base_url}/api/admin/visa`);
      return response.data || [];
    } catch (error) {
      console.error("Error visa applications:", error);
      return [];
    }
  };

  const reloadData = async () => {
    const rows = await fetchVisa();
    setData(rows);
    return rows;
  };

  useEffect(() => {
    reloadData();
  }, [reloadAdminBadges]);

  const openRow = (row) => {
    setRowData(row);
    setCode(row.code);
    setType(row.type);
    setModalOpen(true);
  };

  const handleResolved = async () => {
    setReloadAdminBadges(reloadAdminBadges + 1);
    const rows = await reloadData();
    const justHandled = rowData ? visaKey(rowData) : null;
    const next = rows.find(
      (r) => visaKey(r) !== justHandled && !skippedRef.current.has(visaKey(r))
    );
    if (next) {
      openRow(next);
    } else {
      setModalOpen(false);
      setRowData(null);
      setCode("");
      setType("");
    }
  };

  const handleSkip = async () => {
    if (rowData) skippedRef.current.add(visaKey(rowData));
    const rows = await fetchVisa();
    const next = rows.find(
      (r) => !skippedRef.current.has(visaKey(r))
    );
    if (next) {
      openRow(next);
    } else {
      setModalOpen(false);
      setRowData(null);
      setCode("");
      setType("");
    }
  };

  const columns = [
    { accessorKey: "code", header: "Code" },
    { accessorKey: "name", header: "Name" },
    { accessorKey: "email", header: "Email" },
    { accessorKey: "type", header: "Type" },
    {
      id: "actions",
      header: "Validate",
      Cell: ({ row }) => (
        <button
          onClick={() => openRow(row.original)}
          style={{
            padding: "6px 12px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            background: "#f5f5f5",
            cursor: "pointer",
          }}
        >
          Open
        </button>
      ),
    },
  ];

  return (
    <>
      <div className="text-2xl mt-4 pb-4 font-bold flex gap-8 items-center">
        <Plane />
        Visa Validations
      </div>

      <div style={{ flex: "1 1 0", paddingBottom: "20px" }}>
        <MaterialReactTable columns={columns} data={data} />
      </div>
      <VisaModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        row={rowData}
        code={code}
        type={type}
        onAccept={handleResolved}
        onDecline={handleResolved}
        onSkip={handleSkip}
      />
    </>
  );
};

export default VisaTable;
